import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { BATCH_IMAGES_TYPE } from '@utils/CONST'
import Utils from '@utils/utils'
import { Image } from 'antd';

const RefListModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open: openClick,
    }));

    const { projectType, onSelect } = props

    const [refListVisible, setRefListVisible] = useState(false);
    const [refList, setRefList] = useState([]);

    const openClick = (list) => {
        setRefList(list)
        setRefListVisible(true)
    }

    return <>
        <PSAIModal
            title={'全部商品'}
            maxWidth={750}
            okText={'确定'}
            open={refListVisible}
            maskClosable={true}
            onCancel={() => setRefListVisible(false)}
            onOk={() => setRefListVisible(false)}
            cancelButtonProps={{ style: { display: 'none' } }}
            zIndex={1002}
        >
            <div className={`${styles.createTeamWrap} _beauty_scrollbar`}>
                {
                    refList?.map((item, index) => (
                        <div key={index} className={styles.refListItem} onClick={() => {
                            if (onSelect) {
                                onSelect(item?.url)
                                setRefListVisible(false)
                            }
                        }}>
                            {onSelect ? (
                                <img src={Utils.getImgThumbnail(item?.url)} alt="" />
                            ) : (
                                <Image
                                    src={Utils.getImgThumbnail(item?.url)}
                                    preview={{ src: item?.url }}
                                    alt=""
                                    onClick={(e) => e.stopPropagation()}
                                />
                            )}
                        </div>
                    ))
                }
            </div>
        </PSAIModal >
    </>
})
export default RefListModal
